import AuthDTO from "../../../shared/oversight-core/dtos/request-dtos/auth-dto";
import LoginResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/login-response-dto";
import ServiceProviderListResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/service-provider-list-response-dto";
import { EPrivileges } from "../../../shared/oversight-core/enums/privileges";
import { UserRole } from "../../../shared/oversight-core/enums/user-roles";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import {
  setPrivileges,
  setToken,
  setUserRole,
} from "../../features/auth/auth-slice";
import { rootApi } from "../apiManager";

export const authAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponseDTO, AuthDTO>({
      query(data) {
        return {
          url: "login",
          method: "POST",
          body: data,
        };
      },
      transformErrorResponse,
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          localStorage.setItem("token", res.data.token);
          localStorage.setItem(
            "privileges",
            JSON.stringify(res.data.privileges)
          );
          dispatch(setToken(res.data.token));
          dispatch(setPrivileges(res.data.privileges));
          dispatch(
            setUserRole(
              res.data.privileges.includes(
                EPrivileges.ROLE_SOLAR_DASHBOARD_ADMIN
              )
                ? UserRole.ROLE_SOLAR_DASHBOARD_ADMIN
                : UserRole.ROLE_USER
            )
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    getServiceProviderList: builder.query<ServiceProviderListResponseDTO, void>(
      {
        transformErrorResponse,
        query() {
          return {
            url: `service-providers/list`,
            method: "GET",
          };
        },
      }
    ),
  }),

  overrideExisting: false,
});

export const { useLoginMutation, useLazyGetServiceProviderListQuery } = authAPI;
